import React from "react";

const PanelTitle = ({ children }) => {
  return (
    <div class="panel-heading">
      <h3 class="panel-title">{children}</h3>
    </div>
  );
};

export default PanelTitle;



// WEBPACK FOOTER //
// ./src/_components/UI/Panel/PanelTitle/index.js